import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

function getFacetContainer() {
	return document.querySelector('.on-demand-learning-listing-block .facetwp-facet-on_demand_learning_categories');
}

function addAllTopicsChip() {
	const container = getFacetContainer();
	if (!container) return;
	if (container.querySelector('[data-js="all-topics-chip"]')) return;

	const chip = document.createElement('button');
	chip.type = 'button';
	chip.className = 'facetwp-checkbox all-topics-chip';
	chip.setAttribute('data-js', 'all-topics-chip');
	chip.textContent = 'All topics';

	chip.addEventListener('click', () => {
		if (!window.FWP) return;
		window.FWP.facets.on_demand_learning_categories = [];
		window.FWP.refresh();
	});

	container.prepend(chip);
}

function updateAllTopicsState() {
	const chip = document.querySelector('[data-js="all-topics-chip"]');
	if (!chip || !window.FWP) return;

	const selected = window.FWP.facets?.on_demand_learning_categories || [];
	chip.classList.toggle('is-active', selected.length === 0);
}

function updateCountsLabel() {
	const label = document.querySelector('[data-js="odl-counts-label"]');
	if (!label || !window.FWP || !window.FWP.settings || !window.FWP.settings.pager) return;

	const pager = window.FWP.settings.pager;
	const totalRows = Number(pager.total_rows || 0);
	const page = Math.max(1, Number(pager.page || 1));
	const perPage = Math.max(1, Number(pager.per_page || 1));

	if (totalRows <= 0) {
		label.textContent = 'Showing 0 resources';
		return;
	}

	const start = (page - 1) * perPage + 1;
	const end = Math.min(page * perPage, totalRows);
	label.textContent = `Showing ${start} - ${end} of ${totalRows} resources`;
}

function initListingSpeakerSwipers() {
	const blocks = document.querySelectorAll('.on-demand-learning-listing-block');
	if (!blocks.length) return;

	blocks.forEach((block) => {
		const swipers = block.querySelectorAll('[data-js="odl-listing-speakers-swiper"]');
		if (!swipers.length) return;

		swipers.forEach((el) => {
			if (el.swiper) return;

			const wrapper = el.closest('.media') || el.parentElement;
			const prevEl = wrapper?.querySelector('[data-js="odl-listing-speakers-prev"]');
			const nextEl = wrapper?.querySelector('[data-js="odl-listing-speakers-next"]');
			const paginationEl = wrapper?.querySelector('[data-js="odl-listing-speakers-pagination"]');
			const totalSlides = Number(el.dataset.slides || 1);
			const hasManySlides = totalSlides > 1;

			new Swiper(el, {
				modules: [Navigation, Pagination],
				slidesPerView: 1,
				spaceBetween: 0,
				loop: hasManySlides,
				speed: 450,
				watchOverflow: true,
				allowTouchMove: hasManySlides,
				navigation: {
					prevEl: hasManySlides ? prevEl : null,
					nextEl: hasManySlides ? nextEl : null,
				},
				pagination: {
					el: hasManySlides ? paginationEl : null,
					clickable: true,
					bulletClass: 'odl-bullet',
					bulletActiveClass: 'is-active',
					renderBullet: (index, className) => `<span class="${className}" aria-label="Speaker ${index + 1}"></span>`,
				},
			});
		});
	});
}

export default function onDemandLearningListingBlock() {
	addAllTopicsChip();
	updateAllTopicsState();
	updateCountsLabel();
	initListingSpeakerSwipers();

	document.addEventListener('facetwp-loaded', () => {
		addAllTopicsChip();
		updateAllTopicsState();
		updateCountsLabel();
		initListingSpeakerSwipers();
	});
}
